export const MAX_ALLOWED_FILES = 1000000;
export const MAX_FILE_SIZE = 4000000000000; // 3.7GB
